//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { isValidPastDate } from '@/functions/validators';
import cloneDeep from 'lodash/cloneDeep';
import { get } from 'vuex-pathify';
export default {
  name: 'GuestTableNumberEntry',
  components: {
    FibBackButton: require('@/components/BackButton').default
  },
  data: function data() {
    return {
      tableNumber: ''
    };
  },
  computed: {
    eposData: get('checkIn/eposData'),
    branchDetails: get('config/getBranchDetails'),
    showAboutVisit: get('checkIn/showAboutVisit'),
    visitDetails: get('checkIn/getVisitDetails'),
    isDisabled: function isDisabled() {
      return !(this.tableNumber && this.isNumber(this.tableNumber));
    }
  },
  methods: {
    isNumber: function isNumber(val) {
      var pattern = /^\d+$/;
      return pattern.test(val);
    },
    onSubmit: function onSubmit() {
      var _this$visitDetails;

      // check for epos data, and if available, redirect to questions and return
      if (this.eposData) {
        Logger.debug('epos data available, redirecting to questions');
        this.$router.push('/questions');
        return;
      }

      Logger.debug('epos data NOT available'); // if branch details NOT stored, redirect to find venue and return

      if (!this.branchDetails) {
        Logger.debug('branch details NOT stored, redirecting to find venue');
        this.$router.push('/check_in/find_venue');
        return;
      }

      Logger.debug('branch details stored'); // if visit details stored and valid, redirect to questions and return

      var datetime = cloneDeep((_this$visitDetails = this.visitDetails) === null || _this$visitDetails === void 0 ? void 0 : _this$visitDetails.datetime);
      var visitDetailsValid = isValidPastDate(datetime);

      if (visitDetailsValid) {
        Logger.debug('valid visit details stored, redirecting to questions');
        this.$router.push('/questions');
        return;
      }

      Logger.debug('valid visit details NOT stored');

      if (this.showAboutVisit) {
        Logger.debug('config set to show about visit, redirecting to about visit');
        this.$router.push('/check_in/about_visit');
        return;
      } else {
        // config set to NOT show about visit, redirect to questions and return
        Logger.debug('config set to NOT show about visit, redirecting to questions');
        this.$router.push('/questions');
        return;
      }
    }
  }
};